import { useEffect, useRef, useState } from 'react'

export const useElementScroll = (elementId: string) => {

    const lastEventTimeoutId = useRef(0)

    const calcElementScroll = () => {
        const element = document.getElementById(elementId)
        const scrollToTop = element?.scrollTop ?? 0
        return scrollToTop
    }
    
    const [ scrollToTop, setScrollToTop ] = useState(calcElementScroll())

    useEffect(() => {

        const handleEvent = () => {
            clearTimeout(lastEventTimeoutId.current)
            const timeoutId = setTimeout(() => setScrollToTop(calcElementScroll()), 10)
            lastEventTimeoutId.current = timeoutId as unknown as number
        }

        //listener:
        const element = document.getElementById(elementId)
        element?.addEventListener('scroll', handleEvent)

        return () => element?.removeEventListener('scroll', handleEvent)

    }, [])

    return { scrollToTop }

}
